import { render } from "./AddToCart.vue?vue&type=template&id=3f54a9c7&scoped=true"
import script from "./AddToCart.vue?vue&type=script&lang=js"
export * from "./AddToCart.vue?vue&type=script&lang=js"

import "./AddToCart.vue?vue&type=style&index=0&id=3f54a9c7&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f54a9c7"]])

export default __exports__